export const version = 'v5.7.0';
export const buildDate = '2026-08-12T00:29:38.490Z';
export const commitHash = '1cae3d6';